// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1, h2, h3 {
  padding: 20px;
  background-color: #444;
}

.wizard {
  display: table;
  width: 100%;
  height: 100%;
  display: flex;
}

.steps {
  display: table-cell;
  width: 30%;
}

.steps ul {
  padding-top: 1rem;
  height: 24rem;
}

.content {
  display: table-cell;
  width: 70%;
  height: 100%;
}

.card {
  border: 0;
  padding-top: 8px;
  width: 100%;
  height: 100%;
}

.card-footer {
  align-items: flex-end;
  vertical-align: bottom !important;
  background-color: transparent;
}

.card-footer button {
  align-items: flex-end;
}

.card-header {
  display: none;
}

.card-body {
  height: 20rem;
}

.progress {
  margin: 2rem;
}

.progressSteps {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.selector {
  display: table-row;
}

.selector label {
  display: table-cell;
  padding-right: 0.5rem;
}

.selector select {
  display: table-cell;
}

.selector button {
  display: table-cell;
}

.progressSteps {
  padding-top: 1rem;
}

.progress.backup {
  margin: 1rem;
}

.backup.summary {
  margin-left: 1rem;
}

.deviceSelection label {
  margin-right: 1em;
  width: 5rem;
  height: 15em;
}

.deviceSelection app-dynamic-component,
.deviceSelection app-dynamic-component * {
  height: 13em;
  display: block;
}

.info .name {
  color: var(--bs-card-title-color);
  font-size: 1.5em;
}`, "",{"version":3,"sources":["webpack://./src/app/views/soundbank-flasher/soundbank-flasher.component.scss"],"names":[],"mappings":"AACA;EACI,aAAA;EACA,sBAAA;AAAJ;;AAGA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAAJ;;AAGA;EACI,mBAAA;EACA,UAAA;AAAJ;;AAGA;EACI,iBAAA;EAEA,aAAA;AADJ;;AAIA;EACI,mBAAA;EACA,UAAA;EACA,YAAA;AADJ;;AAIA;EACI,SAAA;EACA,gBAAA;EAEA,WAAA;EACA,YAAA;AAFJ;;AAKA;EACI,qBAAA;EACA,iCAAA;EACA,6BAAA;AAFJ;;AAKA;EACI,qBAAA;AAFJ;;AAKA;EACI,aAAA;AAFJ;;AAKA;EACI,aAAA;AAFJ;;AAKA;EACI,YAAA;AAFJ;;AAKA;EACI,qBAAA;EACA,SAAA;EACA,UAAA;AAFJ;;AAKA;EACI,kBAAA;AAFJ;;AAKA;EACI,mBAAA;EACA,qBAAA;AAFJ;;AAKA;EACI,mBAAA;AAFJ;;AAKA;EACI,mBAAA;AAFJ;;AAKA;EACI,iBAAA;AAFJ;;AAKA;EACI,YAAA;AAFJ;;AAKA;EACI,iBAAA;AAFJ;;AAKA;EACI,iBAAA;EACA,WAAA;EACA,YAAA;AAFJ;;AAKA;;EAEI,YAAA;EACA,cAAA;AAFJ;;AAMA;EACI,iCAAA;EACA,gBAAA;AAHJ","sourcesContent":["\nh1, h2, h3  {\n    padding: 20px;\n    background-color: #444;\n}\n\n.wizard {\n    display: table;\n    width: 100%;\n    height: 100%;\n    display: flex;\n}\n\n.steps {\n    display: table-cell;\n    width: 30%;\n}\n\n.steps ul {\n    padding-top: 1rem;\n\n    height: 24rem;\n}\n\n.content {\n    display: table-cell;\n    width: 70%;\n    height: 100%;\n}\n\n.card {\n    border: 0;\n    padding-top: 8px;\n\n    width: 100%;\n    height: 100%;\n}\n\n.card-footer {\n    align-items: flex-end;\n    vertical-align: bottom !important;\n    background-color: transparent;\n}\n\n.card-footer button {\n    align-items: flex-end;\n}\n\n.card-header {\n    display: none;\n}\n\n.card-body {\n    height: 20rem;\n}\n\n.progress {\n    margin: 2rem;\n}\n\n.progressSteps {\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n}\n\n.selector {\n    display: table-row;\n}\n\n.selector label {\n    display: table-cell;\n    padding-right: 0.5rem;\n}\n\n.selector select {\n    display: table-cell;\n}\n\n.selector button {\n    display: table-cell;\n}\n\n.progressSteps {\n    padding-top: 1rem;\n}\n\n.progress.backup {\n    margin: 1rem;\n}\n\n.backup.summary {\n    margin-left: 1rem;\n}\n\n.deviceSelection label {\n    margin-right: 1em;\n    width: 5rem;\n    height: 15em;\n}\n\n.deviceSelection app-dynamic-component,\n.deviceSelection app-dynamic-component * {\n    height: 13em;\n    display: block;\n}\n\n\n.info .name {\n    color: var(--bs-card-title-color);\n    font-size: 1.5em;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
